import { useState, useCallback } from "react";
import { getPurchasedExpertServices } from "PlatForms/SelfLMS/Services/ExpertService/ExpertServiceLearner";
import { message } from "antd";

export const useExpertServiceLearner = () => {
  const [purchasedServices, setPurchasedServices] = useState([]);
  const [purchasedServicesLoading, setPurchasedServicesLoading] = useState(false);
  const [purchasedServicesError, setPurchasedServicesError] = useState(null);
  const [purchasedServicesPagination, setPurchasedServicesPagination] = useState({
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });

  // Fetch the expert services the learner has (obtained via paid course enrollment)
  const fetchPurchasedServices = useCallback(
    async (page = 1) => {
      setPurchasedServicesLoading(true);
      setPurchasedServicesError(null);

      try {
        const params = {
          pageNumber: page,
          pageSize: purchasedServicesPagination.pageSize,
        };

        const data = await getPurchasedExpertServices(params);
        setPurchasedServices(data.items || []);
        setPurchasedServicesPagination({
          totalCount: data.totalCount,
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
          totalPages: data.totalPages,
        });
      } catch (err) {
        setPurchasedServicesError(err.message || "Failed to fetch purchased services");
        message.error("Failed to load purchased expert services");
      } finally {
        setPurchasedServicesLoading(false);
      }
    },
    [purchasedServicesPagination.pageSize]
  );

  return {
    purchasedServices,
    purchasedServicesLoading,
    purchasedServicesError,
    purchasedServicesPagination,
    fetchPurchasedServices,
  };
};
